import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ph-swing-container"
}
const _hoisted_2 = { class: "ph-swing-select-container form-group" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "ph-swing-list-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ph-swing-form" }
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Tag", -1)
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Quantity", -1)

import { PreHangOption, SwingSelects } from '@/types/preHang';
    import { ref, watch, PropType } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SwingSelect',
  props: {
        selections: { type: Array as PropType<SwingSelects[]>, required: true },
        options: { type: Array as PropType<PreHangOption[]>, required: true },
        fieldName: { type: String, required: true }
    },
  emits: ['updateSwing'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const swingSelect = ref<SwingSelects|undefined>()
    const swings = ref<SwingSelects[]>([])
    const availableSwings = ref<SwingSelects[]>([])

    watch(() => props.selections, () => {
        swings.value = props.selections || []
        setAvailableSwings()
    }, {immediate:true})

    function setAvailableSwings() {
        availableSwings.value = []
        props.options.forEach(opt => {
            const selectedSwing = swings.value.findIndex((x: SwingSelects) => x.optionId == opt.id)
            if(selectedSwing < 0) {
                availableSwings.value.push({
                    ...opt,
                    optionId: opt.id,
                    tag: '',
                    quantity: 0
                })
            } else {
                swings.value[selectedSwing].name = opt.name
            }
        })
        setDefaultSwing()
    }

    function addSwing() {
        if(swingSelect.value) {
            swings.value.push(swingSelect.value)
            removeAvailableSwing(swingSelect.value.id as number)
            emits('updateSwing', swings.value, props.fieldName)
        }
    }

    function removeAvailableSwing(id: number) {
        availableSwings.value = availableSwings.value.filter(x => x.id != id)
        setDefaultSwing()
    }

    function setDefaultSwing() {
        if(availableSwings.value.length > 0) {
            swingSelect.value = availableSwings.value[0]
        } else {
            swingSelect.value = undefined
        }
    }

return (_ctx: any,_cache: any) => {
  return (props.options.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((swingSelect).value = $event)),
            disabled: availableSwings.value.length == 0,
            class: "form-select form-select-sm"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSwings.value, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: option
              }, _toDisplayString(option.name), 9, _hoisted_4))
            }), 128))
          ], 8, _hoisted_3), [
            [_vModelSelect, swingSelect.value]
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: addSwing,
            disabled: availableSwings.value.length == 0
          }, "Add", 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (swings.value.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swings.value, (swing) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "ph-swing-list",
                    key: swing.id
                  }, [
                    _createElementVNode("label", null, _toDisplayString(swing.name || swing.description), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Tag",
                          "onUpdate:modelValue": ($event: any) => ((swing.tag) = $event),
                          onChange: _cache[1] || (_cache[1] = () => emits('updateSwing', swings.value, props.fieldName))
                        }, null, 40, _hoisted_10), [
                          [_vModelText, swing.tag]
                        ]),
                        _hoisted_11
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((swing.quantity) = $event),
                          min: "0",
                          max: "100",
                          step: "1",
                          onChange: _cache[2] || (_cache[2] = () => emits('updateSwing', swings.value, props.fieldName))
                        }, null, 40, _hoisted_13), [
                          [_vModelText, swing.quantity]
                        ]),
                        _hoisted_14
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})